import React from 'react';
import useApi from './useApi';
import { LS_KEYS } from '../hooks';

const BASE_URL = '/client';

export const useClient = () => {
  // ******************************Backoffice********************************

  const { get } = useApi(LS_KEYS.BACKOFFICE);

  /**
   * List all clients
   */
  const list = React.useCallback(async () => {
    const clients = await get(BASE_URL);
    return clients;
  }, [get]);

  /**
   * Load a exist client
   */
  const load = React.useCallback(
    async id => {
      const client = await get(`${BASE_URL}/${id}`);
      return client;
    },
    [get],
  );

  // *********************************Site**********************************

  const { get: getSite, post: postSite, put: putSite } = useApi(LS_KEYS.SITE);

  /**
   * Load logged Client (Site)
   */
  const loadLoggedClient = React.useCallback(async () => {
    const client = await getSite(`${BASE_URL}/site/me`);
    return client;
  }, [getSite]);

  /**
   * Create new client (Site)
   */
  const create = React.useCallback(
    async client => {
      const createdClient = await postSite(BASE_URL, client);
      return createdClient;
    },
    [postSite],
  );

  /**
   * Update logged Client (Site)
   */
  const updateLoggedClient = React.useCallback(
    async client => {
      const updatedClient = await putSite(`${BASE_URL}/site`, client);
      return updatedClient;
    },
    [putSite],
  );

  /**
   * User request a change password email forgot password flow (Site)
   */
  const sendChangePasswordMail = React.useCallback(
    async email => {
      await postSite(`${BASE_URL}/change-password/sendmail`, { email });
    },
    [postSite],
  );

  /**
   * Change password on forgot password flow (Site)
   */
  const changeForgotPassword = React.useCallback(
    async (token, password) => {
      await putSite(`${BASE_URL}/change-password/${token}/forgot`, {
        password,
      });
    },
    [putSite],
  );

  return {
    list,
    load,
    create,
    sendChangePasswordMail,
    changeForgotPassword,
    loadLoggedClient,
    updateLoggedClient,
  };
};

export default useClient;
